var _effectorFileName = "/src/shared/components/contact-modal/contact-modal.tsx";
import { useUnit } from 'effector-react';
import { ContactForm } from '@/shared/components/contact-form/contact-form';
import { $isContactFormSentSuccessfully, contactFormDataSent } from '@/shared/components/contact-form/model';
import { ContactFormData, EntryPoint } from '@/shared/components/contact-form/types';
import { Modal } from '../modal/modal';
interface ContactModalProps {
  children: React.ReactNode;
  entryPoint: EntryPoint;
}
export const ContactModal = (props: ContactModalProps) => {
  const {
    children,
    entryPoint = 'DEFAULT'
  } = props;
  const {
    isContactFormSentSuccessfully,
    onContactFormSend
  } = useUnit({
    isContactFormSentSuccessfully: $isContactFormSentSuccessfully,
    onContactFormSend: contactFormDataSent
  });
  const handleContactFormSubmit = (data: ContactFormData) => {
    onContactFormSend(data);
  };
  return <Modal dialogTrigger={children} entryPoint={entryPoint} title="Оставить заявку" description="Мы&nbsp;свяжемся с&nbsp;вами в&nbsp;мессенджере" isModalSentSuccessfully={isContactFormSentSuccessfully} onModalClosed={() => {}}>
      <ContactForm entryPoint={entryPoint} onFormSubmit={handleContactFormSubmit} />
    </Modal>;
};